module.exports = __webpack_public_path__ + "static/segmentation-search-7d614249fae317f00cd3c2e9d05c4e4c.png";